export {
    DEFAULT_RESULTS_COUNT,
    INITIAL_ARTICLES_COUNT,
    INITIAL_PORTALS_COUNT,
    INITIAL_REQUEST_FORMS_COUNT,
    SHOW_MORE_RESULTS_COUNT,
    ALL_RESULTS_COUNT,
} from './constants';

export {
    StyledContainer,
    SearchResultContainer,
    SectionResultContainer,
    Title,
    Snippet,
    LinkContainer,
    ResultItemContainer,
    StyledThemedButton,
    StyledImage,
    ResultTitleContainer,
    FilterContainer,
    Root,
    MessageTitle,
    HelperText,
    Img,
} from './styled';

export {
    getExternalResourcesCount,
    getSelectedPortalsFromQueryParams,
    formatText,
    useQueryParams,
    isSinglePortalSearch,
    isValidSearchTerm,
    getPortalIdAsNumber,
    getIdsArray,
} from './utils';
